module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightheavyrain@3-9d1e3904c565acaa206a0391e4e43693.png";